import React from "react";
var __jsx = React.createElement;
import { faLocationDot, faUserDoctor } from "@fortawesome/pro-solid-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import { t } from "i18next";
export var ConsultationDetails = function ConsultationDetails(_ref) {
  var encounter = _ref.encounter;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 justify-between mb-3"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] text-left text-gray-500 dark:text-gray-500 mb-1"
  }, encounter.name), /*#__PURE__*/React.createElement("h3", {
    className: "text-base text-left font-semibold text-gray-900 dark:text-gray-100"
  }, encounter.encounter_class, " | ", encounter.encounter_type)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUserDoctor,
    className: "text-gray-500 dark:text-gray-500 mt-0.5",
    size: "sm"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] text-left text-gray-500 dark:text-gray-500"
  }, t("label.provider")), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] text-left text-gray-700 dark:text-gray-300"
  }, encounter.provider || "Not assigned"))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faLocationDot,
    className: "text-gray-500 dark:text-gray-500 mt-0.5",
    size: "sm"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-[12px] text-left text-gray-500 dark:text-gray-500"
  }, t("label.location")), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] text-left text-gray-700 dark:text-gray-300"
  }, encounter.location || "Not specified"))));
};